__turbopack_context__.v({
  "btnContainer": "RealLifeImagesModalContent-module__WzW_ga__btnContainer",
  "btnContainerWrapper": "RealLifeImagesModalContent-module__WzW_ga__btnContainerWrapper",
  "imgContainer": "RealLifeImagesModalContent-module__WzW_ga__imgContainer",
  "root": "RealLifeImagesModalContent-module__WzW_ga__root",
});
